module.exports = __webpack_public_path__ + "img/cert_010.0ebfb413.jpg";